import { InputLabel, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const Label = ({ title, required, style, htmlFor, ...props }) => {
  const theme = useTheme();

  return (
    <InputLabel
      htmlFor={htmlFor}
      {...props}
      sx={{
        marginBottom: "5px",
        fontSize: "1rem",
        color: theme.palette.text.charcoalGrey,
        ...style,
      }}
    >
      {title}
      {required && <span style={{ color: theme.palette.primary.main }}>*</span>}
    </InputLabel>
  );
};

Label.propTypes = {
  title: PropTypes.string.isRequired,
  required: PropTypes.bool,
  labelProps: PropTypes.object,
  htmlFor: PropTypes.string,
};

Label.defaultProps = {
  required: false,
  labelProps: {},
  htmlFor: "",
};

export default Label;
